import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Última rede de segurança: erros fora do alcance do ErrorBoundary do React
// (timers, event handlers, promises) viram uma tela legível com o stack,
// em vez de tela branca — essencial pra diagnosticar em celular.
function erroFatal(msg) {
  if (document.getElementById('erro-fatal')) return
  const div = document.createElement('div')
  div.id = 'erro-fatal'
  div.style.cssText =
    'position:fixed;inset:0;z-index:99999;background:#fff;color:#0f172a;font-family:system-ui;padding:24px;overflow:auto'
  div.innerHTML =
    '<b>Ops, algo deu errado.</b>' +
    '<p style="font-size:13px;color:#64748b">Recarregue a página. Se continuar, mande um print desta tela:</p>' +
    '<pre style="font-size:11px;color:#dc2626;white-space:pre-wrap;background:#f1f5f9;padding:12px;border-radius:10px"></pre>' +
    '<button style="margin-top:12px;padding:10px 20px;background:#0f9d6e;color:#fff;border:0;border-radius:10px;font-weight:600" onclick="location.reload()">Recarregar</button>'
  div.querySelector('pre').textContent = msg + '\n\n' + navigator.userAgent
  document.body.appendChild(div)
}
window.addEventListener('error', (e) => erroFatal(e.error?.stack || e.message))
window.addEventListener('unhandledrejection', (e) => erroFatal(String(e.reason?.stack || e.reason)))

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
